import React from 'react';

const HomePage = () => 
    <>
        <h1><b>Hello, welcome to my blog!</b></h1>
        <p>
            
            This is my first blog website that i have created using with react.js.
        </p>
        <p>
            For the frontend part i used React.js and tailwind css and javascript.<br/>
            To store user response and data in the backend  MongoDb i have used.<br/>
            For the authentication firebase auth service has been used.
        </p>
        <p>
        </p>
    </>


export default HomePage;